import { render, staticRenderFns } from "./PrivacyGuideMsafer.vue?vue&type=template&id=04bf3134&scoped=true"
import script from "./PrivacyGuideMsafer.vue?vue&type=script&lang=js"
export * from "./PrivacyGuideMsafer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf3134",
  null
  
)

export default component.exports